import { IStaticTextsState, IState } from '../store/state';

// this object shall contain all static texts that are used in VTI
// the static text strings reflect the translation tags
// key shall be a combination of the container and another string that describes the uasge or location of the string
// key is always camelCase_camelCase
const staticTextObject : IStaticTextsState = {
    'Countdown_placeYourBets': {content: 'vs::place your bets caps'},
    'Countdown_betstop': {content: 'vs::betstop'},
    'Countdown_live': {content: 'vs::live'},
    'Matchlist_quickBetting': {content: 'vs::quick betting caps'},
    'Header_season': {content: 'vs::season'},
    'Header_match': {content: 'vs::match'},
    'Odds_winner_caps': {content: 'vs::winner caps'},
    'Odds_set_caps': {content: 'vs::set caps'},
    'Odds_currentSet_caps': {content: 'vs::current set caps'},
    'Odds_currentGame_caps': {content: 'vs::current game caps'},
    'Odds_currentPoint_caps': {content: 'vs::current point caps'},
    'Odds_nextGame_caps': {content: 'vs::next game caps'},
    'Odds_nextPoint_caps': {content: 'vs::next point caps'},
    'StatisticsRanking_title': {content: 'vs::ranking'},
    'StatisticsRanking_points': {content: 'vs::points caps'},
    'StatisticsMomentum_title': {content: 'vs::momentum'},
    'StatisticsOverall_title': {content: 'vs::game statistics'},
    'StatisticsOverall_servicePointsWon': {content: 'vs::service points won'},
    'StatisticsOverall_breakPointsWon': {content: 'vs::break points won'},
    'StatisticsOverall_totalPointsWon': {content: 'vs::total points won'},
    'StatisticsOverall_last10Points': {content: 'vs::last 10 points'},
    'StatisticsOverall_aces': {content: 'vs::aces'},
    'StatisticsOverall_doubleFaults': {content: 'vs::double fault'},
    'StatisticsH2H_title': {content: 'vs::head 2 head'},
    'StatisticsH2H_subtitle': {content: 'vs::last 5 matches'},
    'StatisticsForm_title': {content: 'vs::form'},
    'StatisticsForm_subtitle': {content: 'vs::last 5 matches per player'},
    'StatisticsForm_winShort': {content: 'vs::win caps abbr'},
    'StatisticsForm_drawShort': {content: 'vs::draw caps abbr'},
    'StatisticsForm_lossShort': {content: 'vs::loss caps abbr'},
    'StatisticsConfig_title': {content: 'vs::statistic configuration'},
    'StatisticsConfig_overall': {content: 'vs::overall stats'},
    'StatisticsConfig_momentum': {content: 'vs::momentum'},
    'StatisticsConfig_head-2-head': {content: 'vs::head 2 head'},
    'StatisticsConfig_form': {content: 'vs::form'},
    'StatisticsConfig_ranking': {content: 'vs::ranking'},
    'LiveStatisticsBar_Last10ServicePoints': {content: 'vs::service points won'},
    'LiveStatisticsBar_LastServiceGames': {content: 'vs::service games won'},
    'LiveStatisticsBar_Last10TieBreaks': {content: 'vs::tie breaks won ten'},
    'VideoLiveScore_pointflag_point':  {content: 'vs::point'},
    'VideoLiveScore_pointflag_game':  {content: 'vs::game'},
    'VideoLiveScore_pointflag_break':  {content: 'vs::break'},
    'VideoLiveScore_pointflag_set':  {content: 'vs::set'},
    'VideoLiveScore_pointflag_matchvictory':  {content: 'vs::matchvictory'},
    'VideoLiveScore_pointflag_gamepoint':  {content: 'vs::gamepoint'},
    'VideoLiveScore_pointflag_breakpoint':  {content: 'vs::breakpoint'},
    'VideoLiveScore_pointflag_setpoint':  {content: 'vs::setpoint'},
    'VideoLiveScore_pointflag_matchpoint':  {content: 'vs::matchpoint'}
};

// returns an object containing all static texts and their according translation tag
/*
    each property looks like this:
    string: {content: string}
*/
const staticText = (state:IStaticTextsState = staticTextObject, action: any) : IStaticTextsState => {
    return state;
}

// getter for staticTexts

// returns the stores staticTexts property - an object containing all static texts and their according translation tag
/*
    each property looks like this:
    string: {content: string}
*/
export const getStaticText = (state: IState) => {
    return state.staticTexts;
}

export default staticText;
